import { GA4Event } from '@jusbrasil-web/shared-ga4'

import { EVENT } from '../constants'

type PageViewEventProps = {
  resource_id: string | null
  content_group: string
  section: string
  app_id: string
}

export class GA4PageViewEvent extends GA4Event {
  ga4_resource_id: string | null
  ga4_content_group: string
  ga4_section: string
  ga4_app_id: string

  constructor({ resource_id, content_group, section, app_id }: PageViewEventProps) {
    super({ event: EVENT.PAGE_VIEW })
    this.ga4_resource_id = resource_id
    this.ga4_content_group = content_group
    this.ga4_section = section
    this.ga4_app_id = app_id
  }
}
